import axios from "axios";

const BASE_URL = "https://vas.worlinks.com/api/gamerClub/mtn-za-mx";

const MtnZaService = {
  subscribe: async () => {
    const trafficsource = localStorage.getItem("trafficsource");
    const parameter = localStorage.getItem("parameter");
    
    const body = {
      company: trafficsource || null,
      key: parameter || null,
    };
    
    const res = await axios.post(`${BASE_URL}/he`, body);
    return res;
  },

  check: async (params) => {
    const res = await axios.post(`${BASE_URL}/check`, params);
    return res;
  },
};

export default MtnZaService;
